import Helper from "./Helper";

class Breadcrumb {
  constructor(config = {}) {
    const {
      breadcrumb,
      breadcrumbs
    } = config;

    this.breadcrumb = document.querySelector(breadcrumb);
    this.breadcrumbs = Array.prototype.slice.call(document.querySelectorAll(breadcrumbs));
 
    if(this.breadcrumbs && document.documentElement.clientWidth >= 992){
      this.bindEvents();
    }
   
    if(this.breadcrumb && document.querySelector('.ns-anchor-container--hero-magazine')){
      this.deleteBreadcrumb();
    }
  }

  bindEvents() {
    this.breadcrumbs.forEach(breadcrumb => {
      if(!Helper.hasClass(breadcrumb, 'breadcrumbs__item--link')){
        let acrumb = document.createElement('a');
        acrumb.setAttribute('href', document.location.href);
        acrumb.classList.add('breadcrumbs__item--link');
        acrumb.classList.add('breadcrumbs__item');
        acrumb.innerText = breadcrumb.innerText;
        breadcrumb.insertAdjacentElement('afterend', acrumb);
        breadcrumb.remove();
      }
    });
  }

  deleteBreadcrumb(){
    this.breadcrumb.remove();
  }
}

export default Breadcrumb;